import {   postSendRekycApplication } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_SendRequestThunk = createAsyncThunk(
  "reKyc_SendRequestThunk",
  async ({  token }) => {
    try {
      const response = postSendRekycApplication( token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
